


// import React, { useEffect, useState } from "react";

// const PaymentForm = ({ onSuccess, onCancel }) => {
//   const [query, setQuery] = useState("");
//   const [customers, setCustomers] = useState([]);
//   const [totalPending, setTotalPending] = useState(0);

//   const [formData, setFormData] = useState({
//     customer_id: "",
//     investment_amount: "",
//     weekly_interest_amount: "",
//     given_date: "",
//     payment_date: new Date().toISOString().split("T")[0],
//     interest_amount: "",
//     pending_amount: 0,
//   });

//   // 🔍 Search customers
//   useEffect(() => {
//     if (!query) return;

//     fetch(`http://localhost/erp/payments/search-customers.php?q=${query}`)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status) setCustomers(data.customers);
//       });
//   }, [query]);

//   // ✅ Select customer
//   const selectCustomer = async (c) => {
//     setQuery(`${c.customer_code} - ${c.name}`);
//     setCustomers([]);

//     const res = await fetch(
//       `http://localhost/erp/payments/get-week-status.php?customer_id=${c.id}`,
//     );
//     const data = await res.json();

//     let pending = 0;
//     if (data.status) pending = data.pending_total;

//     setTotalPending(pending);

//     setFormData({
//       customer_id: c.id,
//       investment_amount: c.investment_amount,
//       weekly_interest_amount: c.weekly_interest_amount,
//       given_date: c.given_date,
//       payment_date: new Date().toISOString().split("T")[0],
//       interest_amount: c.weekly_interest_amount, // default pay 1 week
//       pending_amount: pending,
//     });
//   };

//   // ✅ Update pending when user changes payable amount
//   // useEffect(() => {
//   //   const pay = parseFloat(formData.interest_amount || 0);
//   //   const pending = parseFloat(totalPending || 0);

//   //   if (pay > pending) return;

//   //   setFormData((prev) => ({
//   //     ...prev,
//   //     pending_amount: pending - pay,
//   //   }));
//   // }, [formData.interest_amount]);


//   // useEffect(() => {
//   //   const pay = Number(formData.interest_amount || 0);
//   //   const weekly = Number(formData.weekly_interest_amount || 0);
//   //   const pending = Number(totalPending || 0);

//   //   // reduce pending only by extra over weekly
//   //   const reduce = Math.max(pay - weekly, 0);
//   //   const newPending = Math.max(pending - reduce, 0);

//   //   setFormData((prev) => ({
//   //     ...prev,
//   //     pending_amount: newPending,
//   //   }));
//   // }, [formData.interest_amount, totalPending]);


//   useEffect(() => {
//   const pay = Number(formData.interest_amount || 0);
//   const weekly = Number(formData.weekly_interest_amount || 0);
//   const pending = Number(totalPending || 0);

//   const reduce = Math.max(pay - weekly, 0);
//   const newPending = Math.max(pending - reduce, 0);

//   setFormData((prev) => ({
//     ...prev,
//     pending_amount: newPending,
//   }));
// }, [formData.interest_amount, totalPending]);


//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const form = new FormData();
//     Object.keys(formData).forEach((k) => form.append(k, formData[k]));

//     const res = await fetch("http://localhost/erp/payments/create.php", {
//       method: "POST",
//       body: form,
//     });

//     const data = await res.json();
//     if (data.status) {
//       alert("Payment Added Successfully ✅");
//       onSuccess();
//     } else {
//       alert("Payment Failed ❌");
//     }
//   };

//   return (
//     <div className="bg-white shadow-xl rounded-xl p-6">
//       <h2 className="text-xl font-bold mb-4">Add Payment</h2>

//       <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
//         {/* Customer Search */}
//         <div className="col-span-2 relative">
//           <label className="text-sm font-bold">Customer</label>
//           <input
//             type="text"
//             value={query}
//             onChange={(e) => setQuery(e.target.value)}
//             className="w-full border px-3 py-2 rounded"
//             placeholder="Search by name or code..."
//           />

//           {customers.length > 0 && (
//             <div className="absolute bg-white border w-full max-h-40 overflow-y-auto z-10">
//               {customers.map((c) => (
//                 <div
//                   key={c.id}
//                   onClick={() => selectCustomer(c)}
//                   className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
//                 >
//                   {c.customer_code} - {c.name}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         <div>
//           <label className="text-sm font-bold">Investment Amount</label>
//           <input
//             value={formData.investment_amount}
//             readOnly
//             className="w-full border px-3 py-2 rounded bg-gray-100"
//           />
//         </div>

//         <div>
//           <label className="text-sm font-bold">Weekly Interest</label>
//           <input
//             value={formData.weekly_interest_amount}
//             readOnly
//             className="w-full border px-3 py-2 rounded bg-gray-100"
//           />
//         </div>

//         <div>
//           <label className="text-sm font-bold">Given Date</label>
//           <input
//             value={formData.given_date}
//             readOnly
//             className="w-full border px-3 py-2 rounded bg-gray-100"
//           />
//         </div>

//         <div>
//           <label className="text-sm font-bold">Payment Date</label>
//           <input
//             type="date"
//             value={formData.payment_date}
//             onChange={(e) =>
//               setFormData({ ...formData, payment_date: e.target.value })
//             }
//             className="w-full border px-3 py-2 rounded"
//           />
//         </div>

//         {/* Total Payable */}
//         <div className="col-span-2">
//           <label className="text-sm font-bold">Total Payable Amount</label>
//           <input
//             type="number"
//             min={0}
//             value={formData.interest_amount}
//             onChange={(e) => {
//               const val = Number(e.target.value);
//               if (val < 0) return;
//               setFormData({ ...formData, interest_amount: val });
//             }}
//             className="w-full border px-3 py-2 rounded font-bold"
//           />
//         </div>

//         {/* Remaining Pending */}
//         <div className="col-span-2">
//           <label className="text-sm font-bold">Remaining Pending</label>
//           <input
//             value={formData.pending_amount}
//             readOnly
//             className="w-full border px-3 py-2 rounded bg-red-50 font-bold text-red-600"
//           />
//         </div>

//         <div className="col-span-2 flex gap-3 mt-4">
//           <button className="bg-indigo-600 text-white px-6 py-2 rounded">
//             Add Payment
//           </button>
//           <button
//             type="button"
//             onClick={onCancel}
//             className="border px-6 py-2 rounded"
//           >
//             Cancel
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default PaymentForm;




import React, { useEffect, useState } from "react";
import { Api } from "../Api/Api";

const PaymentForm = ({ onSuccess, onCancel }) => {
  const [query, setQuery] = useState("");
  const [customers, setCustomers] = useState([]);
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  

  const [formData, setFormData] = useState({
    customer_id: "",
    investment_amount: "",
    weekly_interest_amount: "",
    given_date: "",
    payment_date: new Date().toISOString().split("T")[0],
    interest_amount: "",
    
  });



  /* ---------------- SEARCH CUSTOMER ---------------- */
useEffect(() => {
  if (!query || query.length < 2) {
    setCustomers([]);
    return;
  }

  const controller = new AbortController();

  fetch(`${Api}payments/search-customers.php?q=${query}`, {
    signal: controller.signal,
  })
    .then((r) => r.json())
    .then((d) => {
      if (d.status) setCustomers(d.customers);
      else setCustomers([]);
    })
    .catch(() => {});

  return () => controller.abort();
}, [query]);


  /* ---------------- SELECT CUSTOMER ---------------- */
  const selectCustomer = async (c) => {
    setQuery(`${c.customer_code} - ${c.name}`);
    setCustomers([]);

    
    const res = await fetch(
      `${Api}payments/get-week-status.php?customer_id=${c.id}`,
    );

    const data = await res.json();

  

    setFormData({
      customer_id: c.id,
      investment_amount: c.investment_amount,
      weekly_interest_amount: c.weekly_interest_amount,
      given_date: c.given_date,
      payment_date: new Date().toISOString().split("T")[0],
      interest_amount: "",
      
    });
  };

  


  const submit = async (e) => {
  e.preventDefault();

  const fd = new FormData();
  Object.entries(formData).forEach(([k, v]) => fd.append(k, v));

  // ✅ ADD USER INFO
  fd.append("created_by", currentUser?.username || "");
  fd.append("created_by_id", currentUser?.id || 0);

  const res = await fetch(`${Api}payments/create.php`, {
    method: "POST",
    body: fd,
  });

  const data = await res.json();
  if (data.status) onSuccess();
  else alert("Payment failed");
};


  return (
    <div className="bg-white p-6 rounded shadow">
      <h2 className="text-lg font-bold mb-4">Add Payment</h2>

      <form onSubmit={submit} className="grid grid-cols-2 gap-4">
        {/* CUSTOMER SEARCH */}
        <input
          placeholder="Search customer"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="col-span-2 border p-2 rounded"
        />

        {customers.map((c) => (
          <div
            key={c.id}
            onClick={() => selectCustomer(c)}
            className="col-span-2 cursor-pointer hover:bg-gray-100 p-2"
          >
            {c.customer_code} - {c.name}
          </div>
        ))}

        {/* GIVEN DATE */}
        <div>
          <label className="text-xs font-bold">Loan Date</label>
          <input
            readOnly
            value={formData.given_date}
            className="w-full border p-2 bg-gray-100 rounded"
          />
        </div>

        {/* PAYMENT DATE */}
        <div>
          <label className="text-xs font-bold">Payment Date</label>
          <input
            type="date"
            value={formData.payment_date}
            onChange={(e) =>
              setFormData({ ...formData, payment_date: e.target.value })
            }
            className="w-full border p-2 rounded"
          />
        </div>

        {/* INVESTMENT */}
        <div>
          <label className="text-xs font-bold">Investment Amount</label>
          <input
            readOnly
            value={formData.investment_amount}
            className="w-full border p-2 bg-gray-100 rounded"
          />
        </div>

        {/* WEEKLY */}
        <div>
          <label className="text-xs font-bold">Weekly Interest</label>
          <input
            readOnly
            value={formData.weekly_interest_amount}
            className="w-full border p-2 bg-gray-100 rounded"
          />
        </div>

        {/* PAY AMOUNT */}
    


        <div className="col-span-2">
  <label className="text-xs font-bold">Pay Amount</label>
  <input
    type="text"
    inputMode="numeric"
    pattern="[0-9]*"
    value={formData.interest_amount}
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, "");
      setFormData({ ...formData, interest_amount: value });
    }}
    className="w-full border p-2 rounded font-bold"
  />
</div>



        {/* ACTIONS */}
        <div className="col-span-2 flex gap-2 mt-2">
          <button className="bg-indigo-600 text-white px-4 py-2 rounded">
            Save
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="border px-4 py-2 rounded"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default PaymentForm;
